/**
 * Piece milestone buckets returned in `pieces_status_summary.by_status`
 * on shipment detail and tracking-page API responses.
 */
export const PIECE_MILESTONE_STATUS_ORDER = [
  'shipping soon',
  'shipped',
  'arrived',
  'out for delivery',
  'delivered',
];

/** Read count for a milestone key; backend always sends all five keys. */
export function pieceMilestoneCount(summary, milestoneKey) {
  if (!summary || !summary.by_status) return 0;
  const raw = summary.by_status[milestoneKey];
  const n = Number(raw);
  return Number.isFinite(n) ? n : 0;
}

/** Total non-deleted pieces from summary, with fallback when missing. */
export function pieceMilestoneTotal(summary) {
  if (summary && typeof summary.total === 'number') return summary.total;
  if (!summary || !summary.by_status) return 0;
  return PIECE_MILESTONE_STATUS_ORDER.reduce(
    (sum, key) => sum + pieceMilestoneCount(summary, key),
    0
  );
}
